import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";

//import store and history
import { store, history } from "./store";

//import app
import App from "app";

//Import ie11 polyfills
import "jspolyfill-array.prototype.find";
import "url-search-params-polyfill";
import "react-app-polyfill/ie9";

//import styles
import "react-select/dist/react-select.css";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/styles.css";

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route path="/" component={App} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);
